import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { getCategoryLabel, getSubcategoryLabel } from "../../utils/triviaArcade";

const TriviaQuestionStage = ({ question, compact = false }) => {
  if (!question) return null;

  const categoryLabel = getCategoryLabel(question.category);
  const subcategoryLabel = getSubcategoryLabel(question.subcategory);
  const chipLabel = subcategoryLabel
    ? `${subcategoryLabel} · ${categoryLabel}`
    : categoryLabel;

  return (
    <Box sx={{ textAlign: "center", mb: compact ? 1.5 : 3 }}>
      {chipLabel && (
        <Chip
          label={chipLabel}
          size="small"
          sx={{ mb: compact ? 1 : 2, fontWeight: 600 }}
        />
      )}
      <Typography variant={compact ? "h6" : "h5"} fontWeight={600}>
        {question.question}
      </Typography>
    </Box>
  );
};

export default TriviaQuestionStage;
